import {
  getPreferences,
  savePreferences,
} from '@bingads-webui-campaign/recommendation-preferences';

export function getRecommendationPreferences(preferencesService, isUserLevel = true) {
  return getPreferences(preferencesService, isUserLevel);
}

export function saveRecommendationPreferences(data, preferencesService, isUserLevel = true) {
  savePreferences(preferencesService, data, isUserLevel);
}
